@if (field
  && field.props['list'] 
  && field.props['list'][current_id()] !== undefined 
  && field.props['list'][current_id()].props !== undefined) {
  <section class="gwc-step"
    [class.gwc-step--facility]="field.props['list'][current_id()].props?.['type'] === 'facility_finder'"
    [attr.data-step-id]="field.props['list'][current_id()].props?.['id']">
    <div class="gwc-step__body">
      @if (field.props['list'][current_id()].props?.['type'] !== 'facility_finder') {
        <div class="gwc-step__top">
          <img class="gwc-step__icon"
            alt="step-icon"
            src="assets/wizard/{{billingService.paymentCompleted() ? 'icon-step-payment-completed' : stepForm().props?.['icon']}}.svg"/>
          <div class="gwc-step__top-content">
            <h1>
              {{ billingService.paymentCompleted() ? 'Payment Completed' : stepForm().props?.label }}
            </h1>
            @if (stepForm().props?.['hint'] && !billingService.paymentCompleted()) {
              <h2 [innerHTML]="stepForm().props?.['hint']"></h2>
            }
          </div>
        </div>
      }

      <formly-form [form]="form_obj"
        [model]="model"
        [fields]="stepForm().fieldGroup || []">
      </formly-form>
    </div>
    <div class="gwc-step__buttons">
      <div class="gwc-step__buttons-progress-numbers">
        @if (steps() > 0) {
          {{ current_step() }} of {{ steps() }} 
          @if (['passport', 'idp', 'visa', 'us_passport'].includes(props['product_type'])) {
            | <span class="gwc-step__buttons-progress-numbers-percentage">{{progress()}}%</span>
          }
        }
      </div>
      <div class="gwc-step__buttons-progress-bar-container">
        <mat-progress-bar class="gwc-step__buttons-progress-bar"
          mode="determinate"
          [value]="progress()"></mat-progress-bar>
      </div>
      <div class="gwc-step__buttons-inner">
        <button mat-stroked-button
          type="button"
          class="gwc-button gwc-button--rounded gwc-button--outline"
          [disabled]="current_id() === 0"
          (click)="stepChange('back')">
          Back
        </button>
        @if (current_id() + 1 === field.props['list']?.length) {
          <button mat-flat-button
            color="primary"
            type="button"
            class="gwc-button gwc-button--rounded"
            (click)="finishForm()">
            Finish
          </button>
        } @else {
          <button mat-flat-button
            color="primary"
            type="button"
            class="gwc-button gwc-button--rounded"
            (click)="stepChange('continue')">
            Continue
          </button>
        }
      </div>
    </div>
  </section>
}